import styled from 'styled-components';

export const FooterStrip = styled.footer`
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0.6rem 0;

  background: rgba(255, 255, 255, 0.55);
  backdrop-filter: blur(10px);
  border-top: 1px solid rgba(255, 255, 255, 0.5);
`;

export const FooterInner = styled.div`
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;

  span {
    font-family: var(--font-mono);
    font-size: 0.68rem;
    color: var(--stone-600);
  }

  @media (max-width: 1023px) {
    padding: 0 1rem;
  }

  @media (max-width: 720px) {
    justify-content: flex-start;
  }
`;
